<div class="reportContainer" *ngIf="dataReceived">

    <div fxLayout="row" fxLayoutAlign="start" class="exp-col-cont">
        <button class="button secondary-button" (click)="back()">Back</button>
    </div>
    <div class="title">
        Standard Achievements
    </div>
    <div 
    class="achievements-container"
    fxLayout="row" fxLayoutAlign="center center">

        

        <div class="achievement-block" fxLayout="column">

            <div fxLayout="column">

                <div class="suggested-crown">
                    <i class="fas fa-crown fa-5x"></i> 
                </div>
                <div class="suggested-color">
                    <div class="suggested-font">
                        Suggested
                    </div>
                </div>

            </div>

            
            <div *ngIf="suggestedCount" class="suggested-fraction" fxLayout="row" fxLayoutAlign="center center">

                <div fxLayout="column">
                    <div class="numerator">
                        {{suggestedComplete}}
                    </div>

                    <div class="hr-bg">
                    </div>

                    <div>
                        {{suggestedCount}}
                    </div>
                </div>
            </div>

        </div>

        <!-- <div class="achievement-block" fxLayout="column">

            <div fxLayout="column">

                <div>
                    <i class="far fa-crown fa-5x"></i> 
                </div>

                <div class="suggested-color">
                    <div>
                        Non-Suggested
                    </div>
                </div>

            </div>

            
            <div class="suggested-fraction" fxLayout="row" fxLayoutAlign="center center">

                <div fxLayout="column">
                    <div class="numerator">
                        {{totalComplete - suggestedComplete}}
                    </div>

                    <div class="hr-bg">
                    </div>

                    <div>
                        {{standardsData?.Standards.length - suggestedCount}}
                    </div>
                </div>
            </div>

        </div> -->

        <div class="achievement-block" fxLayout="column">

            <div fxLayout="column">

                <div class="non-suggested-crown">
                    <i class="far fa-crown fa-3x"></i> 
                </div>
                <div class="suggested-color"> 
                    <div class="all-font">
                        All
                    </div>
                </div>

            </div>

            
            <div class="all-fraction all-font" fxLayout="row" fxLayoutAlign="center center">

                <div fxLayout="column">
                    <div class="numerator">
                        {{totalComplete}}
                    </div>

                    <div class="hr-bg">
                    </div>

                    <div>
                        {{standardsData?.Standards.length}}
                    </div>
                </div>
            </div>

        </div>

    </div>

    

 <div class="std-card-container"
    fxLayout="row wrap" fxLayoutAlign="center">
        <div 
        class="std-card"
        (click)="openDetails(standard)" 
        *ngFor="let standard of standardsData?.Standards | orderBy: 'AchievementComplete':'desc' | orderBy: 'Suggested':'desc' " fxLayout="column" fxLayoutAlign="center">

            <div  
            *ngIf="standard?.Suggested"
            class="suggested">
                Suggested
            </div>

            <div class="std-card-header">
                Standard: <b>{{standard.StandardName}}</b>  
            </div>

            <div class="std-card-middle" fxLayout="column" fxLayoutAlign="start center">

                <div 
                [ngClass]="{'suggested-crown' : standard.Suggested && ((standard.ProficientLessons == null ? 0 : standard.ProficientLessons) / standard.LessonProgress.length >= 1),
                 'non-suggested-crown' : !standard.Suggested && ((standard.ProficientLessons == null ? 0 : standard.ProficientLessons) / standard.LessonProgress.length >= 1),
                 'ghosted-crown' : ((standard.ProficientLessons == null ? 0 : standard.ProficientLessons) / standard.LessonProgress.length < 1)}"
                *ngIf="standard.LessonProgress.length"> 
                    <i *ngIf="standard?.Suggested"
                    class="fas fa-crown fa-3x"></i>

                    <i *ngIf="!standard?.Suggested"
                    class="far fa-crown fa-3x"></i> 
                </div>

                <div class="progress-container"
                *ngIf="standard.LessonProgress.length">
                    <div class="progressbar-text" 
                    > 
                      {{ (((standard.ProficientLessons == null ? 0 : standard.ProficientLessons)  / standard.LessonProgress.length)*100).toFixed(0) }}%
                      &nbsp; ({{(standard.ProficientLessons == null ? 0 : standard.ProficientLessons)}} / {{standard.LessonProgress.length}})
                    </div>
                    <div class="progressbar" [ngClass]="((standard.ProficientLessons == null ? 0 : standard.ProficientLessons) / standard.LessonProgress.length >= 1) ? 'success' : 'failure'">
                      <span [style.width]="(((standard.ProficientLessons == null ? 0 : standard.ProficientLessons)  / standard.LessonProgress.length)*100)+'%'"></span>
                    </div>
                </div>

            </div>

            <div class="std-card-bottom">
                <div>
                    {{standard.StandardDescription}}
                </div>
            </div>

            <div class="moreinfo" fxLayout="row" fxLayoutAlign="end">
                more info
            </div>

        </div>
    </div>


</div>

<div *ngIf="!dataReceived" class="spinner-wrapper">
    <div fxLayout="column">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>
  </div>